<template>
  <div>
    <base-dialog :show="!!error" title="An error occured!" @close="handleError">
      <p>{{ error }}</p>
    </base-dialog>

    <base-card>
      <div class="container">
        <div>
          <h2>Members</h2>
          <div>
            <button class="btn">
              <router-link class="link" link to="/register"
                >Add a new Member</router-link
              >
            </button>
          </div>
        </div>

        <div>
          <div>
            <h2>Sort Members by:</h2>
            <select v-model="currentOrder" class="box">
              <option selected>Default</option>
              <option>Date First Contacted</option>
              <option>Date Last Contacted</option>
              <option>Sort By Name</option>
            </select>
          </div>
        </div>
      </div>
      <base-card class="memberCardTwo">
        <div v-show="isLoading">
          <base-spinner></base-spinner>
        </div>
        <div v-if="sortedMember">
          <member-item
            v-show="!isLoading"
            class="memberList"
            v-for="member in sortedMember"
            :key="member.id"
            :id="member.id"
            :firstName="member.firstName"
            :lastName="member.lastName"
            :spouse="member.spouse"
            :houseHold="member.houseHold"
            :connectionGroup="member.connectionGroup"
            :dateFirstContact="member.dateFirstContact"
            :dateLastContact="member.dateLastContact"
            :notes="member.notes"
            @delete-member="deleteSingleMember"
          >
          </member-item>
        </div>
        <div v-else><button @click="getMembers">Get Members</button></div>
      </base-card>
    </base-card>
  </div>
</template>

<script>
import MemberItem from '../components/MemberItem.vue';

    export default {
      components: {
        MemberItem: MemberItem
      },
      data() {
        return {
          currentOrder: 'allMembers',
          isLoading: false,
          error: null,
         
          
        }
      },

          methods: {
            async getMembers(refresh = false ) {
              this.isLoading = true
              try {
              const members = await this.$store.dispatch('members/loadMembers', {forceRefresh: refresh});
               this.isLoading = false;
               return members
              } catch (error) {
                this.error = error.message || 'Something went wrong'
              } 
              
            },

            deleteSingleMember(memberId, groupId) {
              console.log(memberId, ' and ',  groupId)
              this.$store.dispatch('members/removeMember', {id: memberId});
              if(groupId) {
                 this.$store.dispatch('groups/removeFromGroup', {memberId: memberId, id: groupId})
              }
             
            },

            handleError(){
            this.error = null
          }
          }, 
        
          created() {
            this.getMembers();
          },


        computed: {
           sortedMember() {
            if(this.currentOrder === 'Default' ) {
              return this.allMembers
            } else if(this.currentOrder === 'Date First Contacted') {
              return this.membersByFirstContact
            } else if(this.currentOrder === 'Date Last Contacted') {
              return  this.membersByLastContact
            } else if(this.currentOrder === 'Sort By Name') {
              return this.membersByName
            } 
            return this.allMembers
          
          },

          allMembers() {
            const members = this.$store.getters['members/members']
            return members;
          },
          membersByFirstContact() {
            const members = this.$store.getters['members/members']
            members.sort((a, b) => (a.dateFirstContact > b.dateFirstContact) ? 1 : -1)
            return members
          },
          membersByLastContact() {
            const members = this.$store.getters['members/members']
            members.sort((a, b) => (a.dateLastContact > b.dateLastContact) ? -1 : 1)
            return members
          },
          membersByName() {
            const members = this.$store.getters['members/members']
            members.sort((a, b) => (a.lastName > b.lastName) ? 1 : -1)
            return members
          },
        
        },

    }
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

.contain :nth-child(2) {
  background-color: cadetblue;
}

.link {
  text-decoration: none;
  color: white;
}
.btn {
  background-color: cadetblue;
  color: #9a3f3f;
  padding: 0.5rem;
  border: none;
  border-radius: 0.3rem;
  width: 11em;
  font-size: 1em;
}
.box {
  width: 11em;
  height: 2em;
  border: 1px solid #999;
  font-size: 1em;
  color: white;
  background-color: cadetblue;
  border-radius: 5px;
}
.btnContainer {
  display: flex;
  justify-content: space-around;
  padding: 0.3rem;
}

.memberCard {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}
.memberCardTwo {
  
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
      max-width: fit-content;
}

.memberList {
  width: 100%;
}

.memberCardTwo :nth-child(odd of .memberList) {
  background-color: blue;
}

@media only screen and (max-width: 600px) {
  /* .memberCardTwo,
  .card {
    margin: 0 !important;
    padding: 0 !important;
  } */

  .btn {
    width: inherit;
    padding: 0.5rem;
    margin: 0.2rem;
    width: 6rem;
  }
  .container {
    display: inline-block;
    padding-bottom: 1rem;
  }
}
</style>